import { viandas2OpenPdf } from "../../../common/service/viandas2Client";

export const imprimirEtiquetas = (params) =>
  viandas2OpenPdf("/rrhh/reportes/etiquetas", params);

export const imprimirEtiquetasSemana = (params) =>
  viandas2OpenPdf("/rrhh/reportes/etiquetas/semana", params);
